<template>
  <form
    :class="[
      `form`,
    ]"

    novalidate="novalidate"

    @submit="onSubmit"
  >
    <slot />

    <!-- Form Error -->
    <module-error
      v-if="!hasErrorModule"

      :id="id"
    />
  </form>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Utils
import { arrayLoop } from 'utils/array';

// Modules
import ModuleError from 'components/Error';

// Transitions
import TransitionExpandHeight from 'components/ExpandHeight';

// Export
export default {
  name: 'module-form',

  // Components
  components: {
    ModuleError,
    TransitionExpandHeight,
  },

  // Props
  props: {
    id: {
      type: String,
      required: true,
      validator: value => value !== 'global',
    },
    action: {
      type: Function,
    },
    success: {
      type: Function,
    },
    fail: {
      type: Function,
    },
  },

  // Data
  data() {
    return {
      hasErrorModule: false,
    };
  },
  computed: {
    ...mapGetters('forms', [
      'separator',
      'getForm',
      'getField',
      'getFiles',
    ]),
    formState() {
      return (this.getForm(this.id) || {}).state;
    },
  },

  // Methods
  methods: {
    ...mapActions('forms', [
      'setupForm',
      'destroyForm',
      'setFormState',
      'setFormServerError',
      'setFieldServerError',
      'setFormDirty',
      'clearFiles',
    ]),
    setThisFormState(state) {
      this.setFormState({
        id: this.id,
        value: state,
      });
    },
    checkForErrorModule() {
      const slots = this.$slots.default || [];

      let hasErrorModule = false;

      arrayLoop(slots, (i, slot) => {
        if (hasErrorModule) return;

        if ((slot.componentOptions || {}).tag === 'module-error') {
          hasErrorModule = true;
        }
      });

      this.hasErrorModule = hasErrorModule;
    },
    onSubmit(e) {
      e.preventDefault();

      this.setThisFormState('loading');

      setTimeout(() => {
        this.setFormDirty(this.id)
          .then(errorFieldId => {
            if (errorFieldId) {
              this.onError(errorFieldId);
              return;
            }

            if (typeof(this.action) !== 'function') {
              this.setThisFormState('idle');
              return;
            }

            this.action()
              .then(res => this.onSuccess(res))
              .catch(err => this.onFail(err));
          });
      }, 600);
    },
    onError(fieldId) {
      this.setThisFormState('dirty');

      const el = document.querySelector(`[data-fieldset="${fieldId}"]`);

      if (!el) return;

      const bodyRect = document.body.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      const elOffset = elRect.top - bodyRect.top;

      const headerHeight = 100; // TODO: Get this from somewhere

      window.scrollTo({
        top: elOffset - headerHeight,
        left: 0,
        behavior: 'smooth',
      });

      setTimeout(() => el.dispatchEvent(new Event('highlight-error-fieldset')), 400);
    },
    onSuccess(res) {
      this.setThisFormState('success');

      if(this.getFiles.length > 0) {
        this.clearFiles();
      }

      if (typeof(this.success) === 'function') this.success(res);
    },
    onFail(res) {
      this.setThisFormState('dirty');

      const data = res.data || {};
      const errors = data.errors || [];

      let serverError = '';

      arrayLoop(errors, (i, error = {}) => {
        const fieldId = error.field || '';

        if (fieldId && this.getField(`${this.id}${this.separator}${fieldId}`)) {
          this.setFieldServerError({
            id: fieldId,
            formId: this.id,
            error: error.message || true,
          });
        } else if (!serverError) {
          // TODO: This is a hack to get the server error message from MDLive
          serverError = error.message ? error.message : errors.length > 0 ? errors[0] : true;
        }
      });

      this.setFormServerError({
        id: this.id,
        error: serverError,
      });

      if (typeof(this.fail) === 'function') this.fail(res);
    },
  },

  // Lifecycle
  mounted() {
    this.setupForm(this.id);

    this.checkForErrorModule();
  },
  updated() {
    this.checkForErrorModule();
  },
  destroyed() {
    this.destroyForm(this.id);
  },
};
</script>



// WEBPACK FOOTER //
// Form.vue?4827c96d